import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';

export const secureLinkEmailOtpApi = (
  token: string,
  code?: string
): Promise<ApiResponseType<{ sent?: boolean; checked?: boolean }>> => {
  return apiService.POST(`/secure-links/${token}/email-otp/`, code ? { code } : {});
};
